<template>
  <div
    class="view"
    @wheel.prevent
  >
    <div
      @wheel.prevent="wheelHandler"
      :style="styleObject"
      class="wrapper"
      @mousedown.right.stop.prevent="boardMoveStart"
      @click.right.prevent
    >
      <Video-board />
      <image-board />
      <object-board />
      <canvas-board />
    </div>
  </div>
</template>

<script>
import CanvasBoard from '@/components/canvas/content'
import ObjectBoard from '@/components/object/content'
import VideoBoard  from '@/components/video/content'
import ImageBoard  from '@/components/image/content'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Contents',
  data () {
    return {}
  },
  props    : ['boardId'],
  computed : {
    ...mapGetters('room', [
      'scale',
      'position'
    ]),
    styleObject () {
      return {
        '--scale-value' : this.scale / 100,
        top             : `${this.position.y}px`,
        left            : `${this.position.x}px`
      }
    }
  },
  methods: {
    ...mapActions('room', [
      'sendChangeScale',
      'sendMovePosition',
      'sendZoomPoint'
    ]),
    boardMoveStart (e) {
      window.addEventListener('mousemove', this.boardMove, false)
      window.addEventListener('mouseup', this.boardMoveEnd, false)
    },
    boardMove (e) {
      this.sendMovePosition({
        x : this.position.x + e.movementX,
        y : this.position.y + e.movementY
      })
      this.top += e.movementY
      this.left += e.movementX
    },
    boardMoveEnd (e) {
      window.removeEventListener('mousemove', this.boardMove, false)
      window.removeEventListener('mouseup', this.boardMoveEnd, false)
    },
    wheelHandler (e) {
      let beforeScale = this.scale
      let afterScale  = this.scale - e.deltaY / Math.abs(e.deltaY) * (this.scale / 10)
      afterScale = afterScale <= 200 ? afterScale : 200

      var before = {
        x : e.offsetX * beforeScale / 100,
        y : e.offsetY * beforeScale / 100
      }
      var after = {
        x : e.offsetX * afterScale / 100,
        y : e.offsetY * afterScale / 100
      }

      this.sendZoomPoint({
        scale    : afterScale,
        position : {
          x : this.position.x + before.x - after.x,
          y : this.position.y + before.y - after.y
        }
      })
    }
  },
  sockets: {
    connect () {
      this.$socket.emit('joinBoard', this.boardId)
    },
    joinBoard (data) {
      this.imageBoardId = data.imageBoardId
      this.objectBoardId = data.objectBoardId
    }
  },
  components: {
    CanvasBoard,
    ObjectBoard,
    VideoBoard,
    ImageBoard
  }
}
</script>

<style scoped>
.wrapper {
  position    : absolute;
  transform-origin : top left;
  transform   : scale(var(--scale-value));
  user-select : none;
}
.view {
  top: 0px;
  left: 0px;
  position         : absolute;
  width            : 1920px;
  height           : 1080px;
  overflow         : hidden;
  background-color : black;
  transform-origin : top left;
  transform   : scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/room/board.vue